import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  amount: Yup.string().trim().required('msg_error_required_field'),
  date: Yup.string().trim().required('msg_error_required_field'),
});
